// extracted by mini-css-extract-plugin
export default {"banner":"banner_OVgi","text":"text_n3qq","icon":"icon_eS9o","bannerLink":"bannerLink_Z13U"};